import { render, staticRenderFns } from "./homeShebeiDetail.vue?vue&type=template&id=5b8cb9b1&scoped=true&"
import script from "./homeShebeiDetail.vue?vue&type=script&lang=js&"
export * from "./homeShebeiDetail.vue?vue&type=script&lang=js&"
import style0 from "./homeShebeiDetail.vue?vue&type=style&index=0&id=5b8cb9b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8cb9b1",
  null
  
)

export default component.exports